// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
 
  apiKey: "AIzaSyBq7k6mvxEOoGd0-GmBvAFmETURfIPVgiw",
  authDomain: "rodov-index-2021-up.firebaseapp.com",
  databaseURL: "https://rodov-index-2021-up-default-rtdb.firebaseio.com/",
  projectId: "rodov-index-2021-up",
  storageBucket: "rodov-index-2021-up.appspot.com",
  messagingSenderId: "418082676313",
  appId: "1:418082676313:web:b794bdc29e36a940be5b48",
  measurementId: "G-RPMTR34XDR"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
